import { environment } from 'environments/environment';

//declare const webApiUrl: string;
//declare const googleApiKey: string;

let configApp = {
    baseURL: environment.webApiUrl,
    subDomain: "",
    googleApiKey: environment.googleApiKey,
    webTrekkPagePrefix: environment.webTrekkPagePrefix,
    endPoints: {
        ImageProduct: "/api/v3/Product/GetImage",
        Login: "/api/v3/Account/Login",
        LoginToken: "/api/v3/Account/LoginToken",
        GetConfig: "/api/v3/User/GetConfig",
        GetUserRank: "/api/v3/User/Ranking",
        GetUserRankings: "/api/v3/User/GetRankings",
        GetRankingPositions: "/api/v3/User/GetRankingPositions",
        GetTips: "/api/v3/Tip/Get",
        GetPosList: "/api/v3/POS/Get",
        GetPOSType: "/api/v3/POSType/Get",
        GetPOSTypeImage: "/api/v3/POSType/GetImage",
        GetSurvey: "/api/v3/Question/GetQuestionsByGroup",
        GetProducts: "/api/v3/Product/Get",
        PostPOS: "/api/v3/POS/Post",
        PostSpot: "/api/v3/Spot/Post",
        ImagePost: "/api/v3/Spot/PostImages",
        ImageCampaign: "/api/v3/Group/GetImage",
        ImageCampaignBanner: "/api/v3/Group/GetBannerImage",
        EditUser: "/api/v3/User/Edit",
        ProfileImage: "/api/v3/User/GetProfileImage",
        PostLoginRequest: "/api/v3/UserLoginRequest/Post",
        PostForgotPasswordRequest: "/api/v3/User/PasswordRecovery",
    }
};

// Don't edit bellow here
export function GetServiceUrl(name) {
    return configApp.baseURL + configApp.subDomain + configApp.endPoints[name];
}

export function GetUrl(path) {
    return configApp.baseURL + configApp.subDomain + path;
}

export default configApp;
